import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AppButton = styled(Button)(() => ({
	borderRadius: "40px",
	textTransform: "initial",
	padding: "10px 20px",
}));
